module.exports = __webpack_public_path__ + "static/media/man_chauffeur.ff15959b.jpg";